import cls from "./customHeader.module.scss"
import React, {FC} from "react";
import FirstSection from "./FirstSection";
import {IFirstHeader, ISecondHeader} from "../MainLayout";

interface IProps extends IFirstHeader, ISecondHeader {
    isMobile: boolean;
}

const CustomHeader: FC<IProps> = (
    {
        logoPath,
        dbName,
        domain,
        menus,
        hasBlog,
        translationsData,
        selectedLocaleImg,
        locales,
        cacheControlVersion,
        telephone,
        themeOptions
    }
) => {
    return <div className={cls.header}>
        <FirstSection
            dbName={dbName}
            domain={domain}
            logoPath={logoPath}
            menus={menus}
            hasBlog={hasBlog}
            selectedLocaleImg={selectedLocaleImg}
            translationsData={translationsData}
            locales={locales}
            cacheControlVersion={cacheControlVersion}
            telephone={telephone}
            themeOptions={themeOptions}
        />
    </div>
};

export default CustomHeader;